import { createApp } from 'vue'
import App from './v2/views/App.vue'
import router from './v2/router/route'
import { GOOGLE_LOGIN } from './v2/constant/constantApp'

import PrimeVue from 'primevue/config'
import 'primeicons/primeicons.css'
//import Aura from '@primevue/themes/aura'
import Aura from '@primeuix/themes/aura'
import Tooltip from 'primevue/tooltip'
import ToastService from 'primevue/toastservice'
import vue3GoogleLogin from 'vue3-google-login'

import "bootstrap/dist/css/bootstrap.min.css"
import * as bootstrap from 'bootstrap'

/** Icon */
import { OhVueIcon, addIcons } from "oh-vue-icons"
import * as BiIcons from "oh-vue-icons/icons/bi"
import * as FaIcons from "oh-vue-icons/icons/fa"

const Bi = Object.values({ ...BiIcons })
const Fa = Object.values({ ...FaIcons })
addIcons(...Bi,...Fa)

import 'cropperjs/dist/cropper.css'
import 'vue-picture-cropper/style.css'
import './v2/assets/css/layout.css'
//import './v2/assets/css/theme.css'
import './v2/assets/css/mobile.css'
import './v2/assets/css/loader.css'
import './v2/assets/css/placeholder.css'

createApp(App).use(router).use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: 'system',
            cssLayer: false
        }
    }
})
.use(ToastService)
.use(vue3GoogleLogin, {
  clientId: GOOGLE_LOGIN.clientId
}).directive('tooltip', Tooltip).component("v-icon",OhVueIcon).mount('#smp-app')
